import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FocusDirective } from './focus.directive';

@NgModule({
  imports: [
    // other dependencies for the directives to work
    CommonModule
  ],
  declarations: [
      FocusDirective
  ],
  exports: [
    FocusDirective
  ],
  providers: [
    // add any providers here if the directive depends on it
  ]
})
export class ApplicationDirectivesModule {
  // from https://stackoverflow.com/questions/47821680/dependency-in-angular-importing-and-exporting-of-module
  // intended to be imported by AppModule (including services)
  static forRoot() {
    return {
      ngModule: ApplicationDirectivesModule,
      providers: [
        // any providers which need to be accessable through app module
      ]
    }
  }

  // intended to be imported by FeatureModules (excluding services)
  static forChild() {
    return {
      ngModule: ApplicationDirectivesModule,
      providers: []
    }
  }
}